
import { Paginacao, Botao, Corpo, Cores, Icone } from '@componentes-mu/componentes-mu';

import styles from './styles.module.scss'
import { FlexRow } from '../../Flex';

type TableFooterProps = {
    itemsPerPage: number;
    totalItems: number;
    currentPage: number;
    onPageChange: (page: number) => void;
    onItemsPerPageChange: (itemsPerPage: number) => void;
    showExportButton?: boolean;
    showPriorityButton?: boolean;
    onExportClick?: () => void;
    onPriorityClick?: () => void;
}

export const TableFooter = ({ itemsPerPage, totalItems, currentPage, onPageChange, onItemsPerPageChange, showExportButton, showPriorityButton, onExportClick, onPriorityClick }: TableFooterProps) => {
    return (
        <div className={styles.footerTable}>
            <FlexRow gap={"1rem"} alignItems='center'>
                {showPriorityButton && (
                    <Botao
                        tipoComportamento="button"
                        cor={Cores.GradacaoNeutros.CinzaFillMU100}
                        tipo="tipoDefault"
                        style={{ minWidth: "250px" }}
                        onClick={onPriorityClick}
                    >
                        <FlexRow gap={"1rem"} justifyContent='center' alignItems='center'>
                            <Corpo tipo="button1" cor={Cores.CoresIdentidadeMU.azulMu} negrito={700}>
                                Ordernar Prioridade
                            </Corpo>

                            <Icone
                                nome="shuffle"
                                cor={Cores.CoresIdentidadeMU.azulMu}
                                altura="18px"
                                largura="18px"
                            />
                        </FlexRow>
                    </Botao>
                )}
                {showExportButton && (
                    <Botao
                        tipoComportamento="button"
                        cor={Cores.GradacaoNeutros.CinzaFillMU100}
                        tipo="tipoDefault"
                        onClick={onExportClick}
                    >
                        <Corpo tipo="button1" cor={Cores.CoresIdentidadeMU.azulMu} negrito={700}>
                            <FlexRow gap={"1rem"}>
                                Exportar
                                <Icone
                                    nome="download"
                                    cor={Cores.CoresIdentidadeMU.azulMu}
                                    altura="18px"
                                    largura="18px"
                                />
                            </FlexRow>
                        </Corpo>
                    </Botao>
                )}
                <Paginacao
                    itensPorPagina={itemsPerPage}
                    totalItens={totalItems}
                    paginaAtual={currentPage}
                    onPageChange={onPageChange}
                    onItensPorPaginaChange={onItemsPerPageChange}
                />
            </FlexRow>
        </div>
    );
}